// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"6bf633b9","453":"774c9b88","707":"f1d197a0","952":"71d7c71d"}[chunkId] + ".chunk.js";
};